import React, { useState } from "react";
import axios from "axios"; // Axios for making HTTP requests
import { FlutterWaveButton, closePaymentModal } from "flutterwave-react-v3";
import { useSnackbar } from "notistack"; // For showing snackbars (notifications)
import "./hostelrequest.css";

let reference_number;
const HostelRequest = ({ _id, setLoading, studentGender, info }) => {
  const [studentId, setStudentId] = useState(_id); // Track student ID

  const [hostelRequest, setHostelRequest] = useState({
    hostelName: `${
      studentGender === "male"
        ? "MANGACONS BOYS HOSTEL 01"
        : "MANGACONS GIRLS HOSTEL 01"
    }`,
    roomNumber: "",
    bedNumber: "",
    session: "",
    date: "",
    allocationStatus: "Requested",
    paymentStatus: "Paid",
    refNumber: reference_number,
  });

  const { enqueueSnackbar } = useSnackbar(); // Initialize snackbar for notifications

  // Submit hostel request
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/allocation_request/hostel/request`,
        {
          studentId,
          hostelRequest,
        },
      );

      // If successful, show success notification
      enqueueSnackbar("Hostel request submitted successfully!", {
        variant: "success",
      });
      setLoading(false);
    } catch (error) {
      // Show error notification if something goes wrong
      enqueueSnackbar("Error submitting hostel request", { variant: "error" });
      console.error("Error submitting hostel request: ", error);
      setLoading(false);
    }
  };
  const email = "info.mangacons@gmail.com";
  const phone_number = "08063996056";
  const name = "Manga CONS Hostel";

  const config = {
    public_key: `${process.env.REACT_APP_PAYMENT_GATE_KEY}`,
    tx_ref: Date.now(),
    amount: 50000,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      name,
      email,
      phone_number,
    },
    customizations: {
      title: "Manga CONS Allocation Request",
      description: "Payment for hostel",
      logo: "https://mangaconszurufilesbucket.s3.eu-north-1.amazonaws.com/1738333704870_Manga_Cons _Logo3.8a66ad505d6e3f3e47d9.png",
    },
  };

  const fwConfig = {
    ...config,
    text: "Pay now!",
    callback: async (response) => {
      // setLoading(true);
      reference_number = response.tx_ref;
      closePaymentModal(); // Close modal programmatically
      if (response.status === "successful") {
        handleSubmit();

        setLoading(false);
      } else {
        enqueueSnackbar(`Registration failed, please try again later`, {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
        console.log("Payment Failed");
        setLoading(false);
      }
    },
    onClose: () => {},
  };
  return (
    <>
      <div className="fx-cl space3">
        <div className="invoice flex-container">
          {/* First Container */}
          <div className="invoice-first-container">
            <div className="invoice-left-side fx-ac space2">
              <figure className="acctPic">
                <figure className="dp fx-ac">R</figure>
              </figure>
              <div className="fx-cl space1">
                <h1>Request Hostel</h1>
                <p>PAYMENT INVOICE SCHEDULES</p>
              </div>
            </div>
            <div className="invoice-right-side fx-cl space1">
              <p>Manga College of Nursing Sciences</p>
              <p>No. 2 Zuru-Kontagora Road, Amanawa Area</p>
              <p>Zuru LGA, Kebbi State</p>
            </div>
          </div>

          {/* Second Container */}
          <div className="invoice-second-container fx-jb space3">
            <div className="invoice-inner-div">
              <div className=" fx-cl space1">
                <h3>Invoice details</h3>
                <div className="fx-cl">
                  <p>
                    <strong>Hostel Name:</strong> {hostelRequest.hostelName}
                  </p>
                  <p>
                    <strong>Description:</strong> Paymant for Accommodation
                    Allocation
                  </p>
                  <p>
                    <strong>Amount:</strong> 50,000 Naira only
                  </p>
                  <p>
                    <strong>Status:</strong> Un-Paid
                  </p>
                </div>
              </div>
            </div>
            <div className="invoice-inner-div">
              <div className=" fx-cl space1">
                <h3>Billed to</h3>
                <div className="fx-cl">
                  <p>
                    <strong>Name: </strong>
                    {info?.personalInfo.first_Name +
                      " " +
                      info?.personalInfo.sur_Name +
                      " " +
                      info?.personalInfo.other_Name}
                  </p>
                  <p>
                    <strong>Adm number:</strong>{" "}
                    {info?.admission_number ||
                      info?.academicInfo?.admission_number}
                  </p>
                  <p>
                    <strong>Programm:</strong>{" "}
                    {info?.personalInfo.programme_of_study}
                  </p>
                  <p>
                    <strong>Level:</strong> {info?.academicInfo?.level}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Third Container */}
          <div className="invoice-third-container fx-cl space3">
            <div className="fx-cl">
              <h3>Payment details</h3>
              <p>Student registration fees</p>
            </div>

            <div className="invoiceBottom fx-cl fx-jc space2">
              <p style={{ fontSize: "1.2rem", color: "#f00395" }}>
                Kindly note that, payment made is non-refundable. Read Return,
                Refund and Cancellation Policy
              </p>
            </div>
          </div>
        </div>
        <div className="fx-jb">
          <FlutterWaveButton {...fwConfig} className="payInvoice" />
        </div>
      </div>
    </>
  );
};

export default HostelRequest;
